import { create } from 'zustand';
import {
  DEFAULT_APPEARANCE_SETTINGS,
  type AppearanceSettings,
} from '@disenchantment/types';

const STORAGE_KEY = 'appearance-settings';

function load(): AppearanceSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_APPEARANCE_SETTINGS };
    const parsed = JSON.parse(raw) as Partial<AppearanceSettings>;
    return {
      animationsEnabled:
        typeof parsed.animationsEnabled === 'boolean'
          ? parsed.animationsEnabled
          : DEFAULT_APPEARANCE_SETTINGS.animationsEnabled,
    };
  } catch {
    return { ...DEFAULT_APPEARANCE_SETTINGS };
  }
}

function persist(settings: AppearanceSettings): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    /* ignore quota / private mode */
  }
}

interface AppearanceSettingsState extends AppearanceSettings {
  setAnimationsEnabled: (enabled: boolean) => void;
}

export const useAppearanceSettingsStore = create<AppearanceSettingsState>((set) => ({
  ...load(),
  setAnimationsEnabled: (animationsEnabled) => {
    const next = { animationsEnabled };
    persist(next);
    set(next);
  },
}));
